import React from 'react';
import PropTypes from 'prop-types';
import WithImpressions from '../../../WithImpressions';
import './style.scss';

export default function Description({ description = null, biData }) {
    if (!description) { return null; }

    const seller_card_about_me_description = {
        type: 'seller_page.show$viewport',
        seller: {
            id: biData.sellerId
        },
        group: 'seller_card_about_me_description_impression',
        page: {
            ctx_id: biData.pageCtxId,
            component: { name: 'seller_card_about_me_description' },
            element: {
                position: biData.position,
                type: 'text',
                metadata: 'Description',
                name: 'seller_card_about_me_description',
                visible: true
            }
        }
    };

    return (
        <WithImpressions value={seller_card_about_me_description} className="description">
            <h3>{i18n.t('seller_profile.description')}</h3>
            <p>{description}</p>
        </WithImpressions>
    );
}

Description.propTypes = {
    description: PropTypes.string,
    biData: PropTypes.object
};

Description.defaultProps = {
    description: '',
    biData: {}
};



// WEBPACK FOOTER //
// ./src/common/InfoPanel/SellerProfile/Description/index.js